export const getImageDimension = (src: string) => {
  const img = new Image();
  img.src = src;
  return new Promise((resolve, reject) => {
    img.onload = () => {
      const height = img.naturalHeight;
      const width = img.naturalWidth;
      const aspectRatio = width / height;

      // if (height > width) {
      //   aspectRatio = height / width;
      // }
      const desiredWidth = 2; // Set your desired width
      const desiredHeight = desiredWidth / aspectRatio;
      resolve({ height: desiredHeight, width: desiredWidth });
    };
    img.onerror = err => reject(err);
  });
};

export const getImageDimensionV2 = (src: string) => {
  const img = new Image();
  img.src = src;
  return new Promise((resolve, reject) => {
    img.onload = () => {
      const height = img.naturalHeight;
      const width = img.naturalWidth;
      const aspectRatio = height / width;
      const desiredWidth = 2; // Set your desired width
      const desiredHeight = desiredWidth / aspectRatio;
      resolve({ height: desiredHeight, width: desiredWidth });
    };
    img.onerror = err => reject(err);
  });
};

export const downloadImage = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.png`;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBlobImage = (url: string, name?: string) => {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      if (name) {
        a.download = name;
      } else {
        // eslint-disable-next-line no-useless-escape
        a.download = url.replace(/^.*[\\\/]/, '');
      }
      a.href = blobUrl;
      document.body.appendChild(a);
      a.click();
      a.remove();
    })
    .catch(() => {
      downloadImage(url, name || '');
    });
};
